import React from 'react';
import Icon, { IconProps } from './Icon';

/**
 * Building icon for representing buildings, companies, or organizations
 */
export const BuildingIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect>
      <path d="M9 22v-4h6v4"></path>
      <path d="M8 6h.01"></path>
      <path d="M16 6h.01"></path>
      <path d="M8 10h.01"></path>
      <path d="M16 10h.01"></path>
      <path d="M8 14h.01"></path>
      <path d="M16 14h.01"></path>
    </Icon>
  );
};

export default BuildingIcon;
